"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxonomyType = void 0;
var TaxonomyType;
(function (TaxonomyType) {
    TaxonomyType[TaxonomyType["Industry"] = 0] = "Industry";
    TaxonomyType[TaxonomyType["Topic"] = 1] = "Topic";
})(TaxonomyType || (exports.TaxonomyType = TaxonomyType = {}));
